<div class="container-fluid container-border bizz-hier-view">
  @if (lastSyncedDate) {
<div class="last-sync pull-right">
    <label>Last sync: {{ lastSyncedDate }}</label>
  </div>
}
  <ul class="tabs">
    <li [class.active]="activeTab === 'edit'" (click)="tabChange('edit')">Edit</li>
    <li [class.active]="activeTab === 'import'" (click)="tabChange('import')">Import</li>
  </ul>

  @if (activeTab === 'edit') {
<div class="tab-content">
    <div class="toolbar toolbar-edit">
      <div class="toolbar-left">
        @if (editTree.length > 0) {
<i
          class="fa folder-toggle"
         
          [ngClass]="{ 'fa-folder-open': !collapsed, 'fa-folder': collapsed }"
          (click)="toggleCollapse()"></i>
}
        <span class="bh-title">Business Hierarchy</span>
        @if (loading) {
<span class="tree-loading-icon"><i class="fa fa-spinner fa-pulse"></i></span>
}
      </div>
      <div class="toolbar-right">
        <div class="icon-actions">
          @if (showActions === 'N') {
<i
           
            class="fa fa-plus"
            ap-tooltip [appendAfterTarget]="true" tooltipContent="New Root BU"
            direction="top"
            (click)="openAddRoot()"></i>
}
          @if (editTree.length > 0) {
<i
           
            class="fa fa-file-excel-o"
            ap-tooltip [appendAfterTarget]="true" tooltipContent="Export BH Data"
            direction="top"
            (click)="exportTreeToExcel('edit')"></i>
}
          @if (editTree.length > 0) {
<i
           
            class="fa fa-refresh"
            ap-tooltip [appendAfterTarget]="true" tooltipContent="Refresh BH"
            direction="top"
            (click)="refreshEditTree()"></i>
}
        </div>
        @if (editTree.length > 0) {
<div class="search-wrap">
          <input class="form-control input-sm search" [(ngModel)]="searchEdit" placeholder="search" />
          <i class="fa fa-search"></i>
        </div>
}
      </div>
    </div>

    <div class="tree-wrap">
      @if (!loading && editTree.length === 0) {
<div class="alert-message">There is no data available</div>
}
      <ul class="tree-list">
        <ng-container *ngTemplateOutlet="editNodeTpl; context: { $implicit: editTree }"></ng-container>
      </ul>
    </div>
  </div>
}

  @if (activeTab === 'import') {
<div class="tab-content">
    <div class="toolbar toolbar-import">
      <div class="toolbar-left import-actions"></div>
      <div class="toolbar-right search-wrap">
        <input class="form-control input-sm search" [(ngModel)]="searchImport" placeholder="search" />
        <i class="fa fa-search"></i>
      </div>
    </div>

    <div class="import-grid">
      <div class="pane left-pane">
        <div class="pane-toolbar">
          <div class="btn-group" (click)="openHierarchyExcelModel($event)">
            <button type="button" class="btn btn-xs btn-default dark-btn"><i class="fa fa-upload"></i></button>
            <button type="button" class="btn btn-xs btn-info">Import New Tree</button>
          </div>
        </div>
        <h5>Imported Tree</h5>
        @if (importAlertMessage) {
<div class="alert-message import-placeholder">{{ importAlertMessage }}</div>
}
        <ul class="tree-list">
          <ng-container *ngTemplateOutlet="importNodeTpl; context: { $implicit: importTree }"></ng-container>
        </ul>
      </div>
      <div class="compare-pane">
        <div class="inner-col-color" (click)="compareImportVsCurrent()">
          <div class="show-diff-img"><i class="fa fa-cogs"></i></div>
          <div>Show Difference</div>
        </div>
        @if (treeCompared) {
<div class="info">
          <span><i class="legend-dot legend-existing"></i>Existing Nodes: {{ onlyInCurrentCount }}</span>
          <span><i class="legend-dot legend-new"></i>New Nodes In Import: {{ onlyInImportCount }}</span>
          <span><i class="legend-dot legend-moved"></i>Nodes Moved: {{ movedCount }}</span>
        </div>
}
      </div>
      <div class="pane right-pane">
        <div class="pane-toolbar">
          <div class="btn-group" (click)="loadTree('right')">
            <button type="button" class="btn btn-xs btn-default dark-btn"><i class="fa fa-download"></i></button>
            <button type="button" class="btn btn-xs btn-info">Get Current Tree</button>
          </div>
        </div>
        <h5>Current Tree</h5>
        @if (currentAlertMessage) {
<div class="alert-message import-placeholder">{{ currentAlertMessage }}</div>
}
        <ul class="tree-list">
          <ng-container *ngTemplateOutlet="currentNodeTpl; context: { $implicit: currentTreeForImport }"></ng-container>
        </ul>
      </div>
    </div>
  </div>
}
</div>

@if (showImportTreeModal) {
<div class="modal-overlay">
  <div class="modal-content-box import-tree-modal">
    <div class="modal-header">
      <h3 class="modal-title"><strong>CREATE HIERARCHY</strong></h3>
      <div class="header-actions">
        <i class="fa"
           [class.fa-plus-square-o]="minimiseImport"
           [class.fa-minus-square-o]="!minimiseImport"
           style="cursor: pointer;"
           role="button"
           tabindex="0"
           [attr.title]="minimiseImport ? 'Restore' : 'Minimize'"
           [attr.aria-label]="minimiseImport ? 'Restore' : 'Minimize'"
           (click)="minimiseImport = !minimiseImport"
           (keydown.enter)="minimiseImport = !minimiseImport"
           (keydown.space)="$event.preventDefault(); minimiseImport = !minimiseImport"></i>
        <i class="fa fa-times" style="cursor: pointer;" (click)="closeImportTreeModal()"></i>
      </div>
    </div>
    <div class="modal-body" [hidden]="minimiseImport">
      <div class="form-group">
        <label>Include Header</label>
        <input type="checkbox" [(ngModel)]="importSkipHeader" />
      </div>
      <div class="form-group import-file-row">
        <input class="form-control input-sm" [value]="importFileName" disabled />
        <button class="btn btn-sm btn-default" type="button" (click)="openImportFileDialog()">Upload</button>
      </div>
      <input
        id="import-bh-file-modal"
        type="file"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        (change)="onImportFileChange($event)"
        style="display: none;" />
    </div>
    <div class="modal-footer" [hidden]="minimiseImport">
      <button class="btn btn-sm btn-warning" type="button" (click)="closeImportTreeModal()">Cancel</button>
      <button class="btn btn-sm btn-info" type="button" [disabled]="!importFile || importLoading" (click)="confirmImportTree()">
        Import @if (importLoading) {
<i class="fa fa-spinner fa-pulse"></i>
}
      </button>
    </div>
  </div>
</div>
}

<ng-template #editNodeTpl let-nodes>
  @for (node of nodes; track $index) {
<li>
    @if (isNodeVisible(node, 'edit')) {
<div class="node-row"
      [ngClass]="{
        'level-1-style': !node?.meParentKey,
        'absent-in-right-tree': node?.absentInRightTree,
        'node-moved': node?.nodeMoved,
        'absent-in-left-tree': node?.absentInLeftTree,
        'node-edited': node?.nodeEdited,
        'highlight-node': node?.highlightNode,
        'moving-node': isMovingSource(node)
      }"
     >
      <span
        class="node-label"
        (click)="toggleNode(node, $event)">
        <i class="fa folder-icon" [ngClass]="nodeChildren(node)?.length ? 'fa-folder-open' : 'fa-folder-o'"></i>
        {{ nodeName(node) }} ({{ nodeCode(node) }})
      </span>
      <span class="actions">
        @if (!isMovingSource(node) && !moveNodeRef) {

          @if (showActions !== 'Y' && isNodeEditable(node)) {
<i class="fa fa-retweet" ap-tooltip [appendAfterTarget]="true" tooltipContent="Redirect BU" direction="top" (click)="openRedirect(node); $event.stopPropagation()"></i>
}
          @if (showActions !== 'Y' && isNodeEditable(node)) {
<i class="fa fa-share" ap-tooltip [appendAfterTarget]="true" tooltipContent="Select BU To Move" direction="top" (click)="startMove(node); $event.stopPropagation()"></i>
}
          @if (showActions !== 'Y' && isNodeEditable(node)) {
<i class="fa fa-trash-o" ap-tooltip [appendAfterTarget]="true" tooltipContent="Delete BU" direction="top" (click)="deleteBu(node); $event.stopPropagation()"></i>
}
          @if (showActions !== 'Y' && isNodeEditable(node)) {
<i class="fa fa-edit" ap-tooltip [appendAfterTarget]="true" tooltipContent="Edit BU" direction="top" (click)="openEdit(node); $event.stopPropagation()"></i>
}
          @if (showActions !== 'Y') {
<i class="fa fa-plus" ap-tooltip [appendAfterTarget]="true" tooltipContent="Add Child BU" direction="top" (click)="openAddChild(node); $event.stopPropagation()"></i>
}
        
}
        @if (isMovingSource(node)) {
<i class="fa fa-angle-double-up" ap-tooltip [appendAfterTarget]="true" tooltipContent="Move BU To Root" direction="top" (click)="moveToRoot(node); $event.stopPropagation()"></i>
}
        @if (isMovingSource(node)) {
<i class="fa fa-times" ap-tooltip [appendAfterTarget]="true" tooltipContent="Cancel Move" direction="top" (click)="cancelMove(); $event.stopPropagation()"></i>
}
        @if (moveNodeRef && !isMovingSource(node) && canDropOnNode(node)) {
<i class="glyphicon glyphicon-inbox" ap-tooltip [appendAfterTarget]="true" tooltipContent="Drop Selected BU Here" direction="top" (click)="dropMoveOnNode(node); $event.stopPropagation()"></i>
}
      </span>
    </div>
}
    @if (!collapsed && !isNodeCollapsed(node) && nodeChildren(node)?.length) {
<ul class="tree-list">
      <ng-container *ngTemplateOutlet="editNodeTpl; context: { $implicit: nodeChildren(node) }"></ng-container>
    </ul>
}
  </li>
}
</ng-template>

<ng-template #importNodeTpl let-nodes>
  @for (node of nodes; track $index) {
<li>
    @if (isNodeVisible(node, 'import')) {
<div
      class="node-row"
      [ngClass]="{
        'absent-in-right-tree': node?.absentInRightTree,
        'node-moved': node?.nodeMoved,
        'absent-in-left-tree': node?.absentInLeftTree,
        'node-edited': node?.nodeEdited,
        'highlight-node': node?.highlightNode
      }"
     >
      <span class="node-label"><i class="fa folder-icon" [ngClass]="nodeChildren(node)?.length ? 'fa-folder-open' : 'fa-folder-o'"></i>{{ nodeName(node) }} ({{ nodeCode(node) }})</span>
      <span class="actions">
        @if (node?.presentInrightTree) {
<i class="fa fa-angle-double-right" ap-tooltip [appendAfterTarget]="true" tooltipContent="Auto Push BU" direction="top" (click)="autoPushFromImport(node)"></i>
}
      </span>
    </div>
}
    @if (nodeChildren(node)?.length) {
<ul class="tree-list">
      <ng-container *ngTemplateOutlet="importNodeTpl; context: { $implicit: nodeChildren(node) }"></ng-container>
    </ul>
}
  </li>
}
</ng-template>

<ng-template #currentNodeTpl let-nodes>
  @for (node of nodes; track $index) {
<li>
    @if (isNodeVisible(node, 'import')) {
<div
      class="node-row"
      [ngClass]="{
        'absent-in-right-tree': node?.absentInRightTree,
        'node-moved': node?.nodeMoved,
        'absent-in-left-tree': node?.absentInLeftTree,
        'node-edited': node?.nodeEdited,
        'highlight-node': node?.highlightNode
      }"
     >
      <span class="node-label"><i class="fa folder-icon" [ngClass]="nodeChildren(node)?.length ? 'fa-folder-open' : 'fa-folder-o'"></i>{{ nodeName(node) }} ({{ nodeCode(node) }})</span>
    </div>
}
    @if (nodeChildren(node)?.length) {
<ul class="tree-list">
      <ng-container *ngTemplateOutlet="currentNodeTpl; context: { $implicit: nodeChildren(node) }"></ng-container>
    </ul>
}
  </li>
}
</ng-template>

@if (showBuModal) {
<div class="modal-overlay">
  <div class="modal-content-box">
    <div class="modal-header">
      <h3 class="modal-title"><strong>{{ editMode ? 'Edit Business Unit' : 'Create Business Unit' }}</strong></h3>
      <div class="header-actions">
        <i class="fa"
           [class.fa-plus-square-o]="minimiseBu"
           [class.fa-minus-square-o]="!minimiseBu"
           style="cursor: pointer;"
           role="button"
           tabindex="0"
           [attr.title]="minimiseBu ? 'Restore' : 'Minimize'"
           [attr.aria-label]="minimiseBu ? 'Restore' : 'Minimize'"
           (click)="minimiseBu = !minimiseBu"
           (keydown.enter)="minimiseBu = !minimiseBu"
           (keydown.space)="$event.preventDefault(); minimiseBu = !minimiseBu"></i>
        <i class="fa fa-times" style="cursor: pointer;" (click)="closeBuModal()"></i>
      </div>
    </div>
    <div class="modal-body" [hidden]="minimiseBu">
      <label>BU Code</label>
      <input class="form-control input-sm" [(ngModel)]="buCode" />
      <label>BU Description</label>
      <input class="form-control input-sm" [(ngModel)]="buDesc" />
      <label>Line Of Business</label>
      <select class="form-control input-sm" [(ngModel)]="buLob">
        <option value="IND">IND</option>
        <option value="FIN">FIN</option>
      </select>
      <label>Detail BSLA</label>
      <select class="form-control input-sm" [(ngModel)]="buDetailBsla">
        <option value="Y">Yes</option>
        <option value="N">No</option>
      </select>
      <label>EST Data Collection</label>
      <select class="form-control input-sm" [(ngModel)]="buEstDataCollection">
        <option value="BU">Business</option>
        <option value="LE">Legal Entity</option>
      </select>
    </div>
    <div class="modal-footer" [hidden]="minimiseBu">
      <button class="btn btn-sm btn-info" type="button" (click)="submitBu()">{{ editMode ? 'Save' : 'Create' }}</button>
      <button class="btn btn-sm btn-warning" type="button" (click)="closeBuModal()">Cancel</button>
    </div>
  </div>
</div>
}

@if (showRedirectModal) {
<div class="modal-overlay">
  <div class="modal-content-box redirect-modal">
    <div class="modal-header">
      <h3 class="modal-title"><strong>Redirect Business</strong></h3>
      <div class="header-actions">
        <i class="fa"
           [class.fa-plus-square-o]="minimiseRedirect"
           [class.fa-minus-square-o]="!minimiseRedirect"
           style="cursor: pointer;"
           role="button"
           tabindex="0"
           [attr.title]="minimiseRedirect ? 'Restore' : 'Minimize'"
           [attr.aria-label]="minimiseRedirect ? 'Restore' : 'Minimize'"
           (click)="minimiseRedirect = !minimiseRedirect"
           (keydown.enter)="minimiseRedirect = !minimiseRedirect"
           (keydown.space)="$event.preventDefault(); minimiseRedirect = !minimiseRedirect"></i>
        <i class="fa fa-times" style="cursor: pointer;" (click)="closeRedirect()"></i>
      </div>
    </div>
    <div class="modal-body" [hidden]="minimiseRedirect">
      <div class="infoContainer">
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        Please select target business for each source business to redirect.
      </div>
      <div class="redirect-grid">
        <div class="col col-source">
          <div class="col-header">Source</div>
          <div class="sub-header">
            <div>BU Name</div>
            <div>BU Code</div>
          </div>
          <div class="rows">
            @for (row of sourceBuList; track $index; let i = $index) {
<div class="row-item">
              <div>{{ row.name }}</div>
              <div>{{ row.mekey }}</div>
            </div>
}
          </div>
        </div>
        <div class="col col-search">
          <div class="col-header">Search</div>
          <div class="rows">
            @for (row of targetBuList; track $index; let i = $index) {
<div class="row-item">
              <input class="form-control input-sm"
                     placeholder="Enter keyword to search"
                     [(ngModel)]="row.targetSearchText"
                     (ngModelChange)="searchTargets(i)" />
              @if (row.showCancelBtn) {
<i class="fa fa-times-circle clear-icon cancelBtn" (click)="clearTarget(i)"></i>
}
              @if (row.showList) {
<div class="dropdown-list">
                @for (target of allBuList; track $index) {
<div
                  class="dropdown-item"
                 
                  [hidden]="!(target.label || '').toLowerCase().includes((row.targetSearchText || '').toLowerCase())"
                  (click)="pickTarget(i, target)">
                  {{ target.label }}
                </div>
}
              </div>
}
            </div>
}
          </div>
        </div>
        <div class="col col-target">
          <div class="col-header">Target</div>
          <div class="sub-header">
            <div>BU Name</div>
            <div>BU Code</div>
          </div>
          <div class="rows">
            @for (row of targetBuList; track $index; let i = $index) {
<div class="row-item">
              <div>{{ row.name }}</div>
              <div>
                {{ row.mekey }}
                @if (row.selected) {
<i class="fa fa-times-circle clear-icon" (click)="clearTarget(i)"></i>
}
              </div>
            </div>
}
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer" [hidden]="minimiseRedirect">
      <button class="btn btn-sm btn-success" type="button" (click)="saveRedirect(false)" [disabled]="redirectBtn || redirectLoading || redirectDeleteLoading">
        Redirect @if (redirectLoading) {
<i class="fa fa-spinner fa-pulse"></i>
}
      </button>
      <button class="btn btn-sm btn-success" type="button" (click)="saveRedirect(true)" [disabled]="redirectDeleteBtn || redirectLoading || redirectDeleteLoading">
        Redirect and Delete @if (redirectDeleteLoading) {
<i class="fa fa-spinner fa-pulse"></i>
}
      </button>
      <button class="btn btn-sm btn-warning" type="button" (click)="closeRedirect()">Cancel</button>
    </div>
  </div>
</div>
}

<!-- Confirmation Dialog using shared confirmation modal -->
<!-- Note: showConfirmDialog controls the entire modal visibility (overlay + modal) -->
<!-- The [visible] property controls the modal header visibility, set to true when modal is shown -->
@if (showConfirmDialog) {
<div class="modal-overlay confirmation-overlay">
  <div class="modal-dialog confirmation-dialog" (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="confirmModalConfig"
      [visible]="false"
      (confirmed)="onConfirmAction()"
      (cancelled)="onCancelConfirm()"
      (closed)="onCancelConfirm()">
    </gtw-confirmation-modal>
  </div>
</div>
}

